import { Grid, useMediaQuery } from '@mui/material';
import Navbar from 'components/Navbar';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import { useQuery } from '@apollo/client';
import LoadingIndicator from 'components/LoadingIndicator';
import {
  GET_DASHBOARD_QUERY,
  GetDashboardResponse,
  GetDashboardVariables,
} from 'graphql/query/dashboard';
import DoughnutChart from 'components/Dashboard/Chart/index';
import Legends from 'components/Dashboard/Chart/legends';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

ChartJS.register(ArcElement, Tooltip);

const Dashboard = () => {
  const isDesktopScreen = useMediaQuery('(min-width:1440px)');

  const { data: dashboard, loading: loadingDashboard } = useQuery<
    GetDashboardResponse,
    GetDashboardVariables
  >(GET_DASHBOARD_QUERY, {
    variables: {
      year: getSelectedObjectiveGoalsYear(),
    },
    fetchPolicy: 'network-only',
  });

  return (
    <Navbar title={`Dashboard - ${getSelectedObjectiveGoalsYear()}`}>
      {loadingDashboard ? (
        <LoadingIndicator />
      ) : (
        <Grid
          container
          display="flex"
          justifyContent="center"
          alignItems="center"
          columnGap={2}
          pt={!isDesktopScreen ? undefined : 10}
          position="relative"
          rowGap={10}
        >
          <Grid
            item
            container={isDesktopScreen ? undefined : true}
            justifyContent={'center'}
            position={isDesktopScreen ? 'absolute' : undefined}
            top={isDesktopScreen ? 20 : undefined}
            right={20}
            mb={-5}
            zIndex={10}
            xs={12}
          >
            <Legends />
          </Grid>
          <Grid item sx={{ height: 240 }}>
            <DoughnutChart
              data={dashboard?.getDashboard?.startYear?.map(o => o.value) ?? []}
              title="Objective Settings"
            />
          </Grid>
          <Grid item sx={{ height: 240 }}>
            <DoughnutChart
              data={dashboard?.getDashboard?.midYear?.map(o => o.value) ?? []}
              title="Mid Year Review"
            />
          </Grid>
          <Grid item sx={{ height: 240 }}>
            <DoughnutChart
              data={dashboard?.getDashboard?.endYear?.map(o => o.value) ?? []}
              title="End Year Review"
            />
          </Grid>
        </Grid>
      )}
    </Navbar>
  );
};

export default Dashboard;
